import { featureMemberSwitches, featureProviderSwitches } from '@fireflyhealth/api'
import keyBy from 'lodash/fp/keyBy'
import { useSelector } from 'react-redux'
import { useQuery } from '~/shared/hooks/query'
export const useFeatureSwitches = () => {
  const me = useSelector(state => state.me)
  const authenticated = me?.id != null
  const switches = authenticated ? featureProviderSwitches : featureMemberSwitches

  const fetchSwitches = () => switches.list().then(r => r.data)
  const query = useQuery(switches.listQueryKey(), fetchSwitches, { staleTime: Infinity })

  return {
    ...query,
    data:
      query.data != null
        ? { featureSwitches: query.data, featureSwitchesByName: keyBy('name', query.data) }
        : undefined,
  }
}

/**
 * Returns the feature switch with the given name. Note that before switches are
 * loaded, this will return null.
 *
 * @knipskip - As switches are cleaned up, this will become unused from time to
 * time.
 */
export const useFeatureSwitch = (name: string) => {
  const { data } = useFeatureSwitches()
  return data?.featureSwitchesByName?.[name] ?? null
}
